import Agent from '../agent'

export const WX_PATH_PREFIX = {
  dianping: '/packages/dynamic-zhenguo-hybrid/pages',
  dianpingSub: '/packages/dynamic-zhenguo-hybrid/subpackage',
  meituan: '/zhenguo/pages',
  hotel: '/pkg/zhenguo/pages',
  hotelSub: '/pkg/zhenguo/subpackage',
  phx: '/pages',
  phxSub: '/subpackage/secondary',
}

export interface MP_PATH_MAP {
  dianping_wxapp?: string
  group_wxapp?: string
  hotel_wxapp?: string
  phoenix_wxapp: string
  [x: string]: string | undefined
}

export const appUsernameMap: Record<string, string> = {
  hotel_wxapp: 'gh_d5ea568e0053',
  ticket_wxapp: 'gh_8dc6c08b45e2',
  dianping_wxapp: 'gh_bc5b635c05c4',
  group_wxapp: 'gh_870576f3c6f9',
  phoenix_wxapp: 'gh_8c04beb7e27c',
}

const appIdMap: Record<string, string> = {
  hotel_wxapp: 'wx7649daed8f2335c4',
  ticket_wxapp: 'wx4fa555703dced95c',
  dianping_wxapp: 'wx734c1ad7b3562129',
  group_wxapp: 'wxde8ac0a21135c07d',
  phoenix_wxapp: 'wxc147016e2b3bf9d6',
}

export function mpWebviewMap(
  iUrl: string,
  { appnm, isLaunch }: { appnm?: string; isLaunch?: boolean } = {},
): MP_PATH_MAP {
  const zhenguoWebview = `/web/web${isLaunch ? '.html' : ''}?openUrl=${encodeURIComponent(iUrl)}`
  const webviewPath: MP_PATH_MAP = {
    ticket_wxapp: `/pages/webview/index${isLaunch ? '.html' : ''}?url=${encodeURIComponent(iUrl)}`, // 门票小程序默认 webview
    hotel_wxapp: `${WX_PATH_PREFIX.hotel}${zhenguoWebview}`,
    dianping_wxapp: `${WX_PATH_PREFIX.dianpingSub}/dynamic-page/index${
      isLaunch ? '.html' : ''
    }?case=pages-web-web&openUrl=${encodeURIComponent(iUrl)}`,
    group_wxapp: `${WX_PATH_PREFIX.meituan}${zhenguoWebview}`,
    phoenix_wxapp: `${WX_PATH_PREFIX.phx}${zhenguoWebview}`,
  }
  // 跳转其它小程序场景
  if (appnm && Agent.appnm !== appnm) {
    const path = encodeURIComponent((webviewPath[appnm] as string).slice(1))
    return {
      phoenix_wxapp: `/index/pages/mina-navigation/index?appId=${appIdMap[appnm]}&path=${path}`,
      hotel_wxapp: `/pages/mina-navigation/index?appId=${appIdMap[appnm]}&path=${path}`,
      ticket_wxapp: `/pages/mina-navigation/index?appId=${appIdMap[appnm]}&path=${path}`,
    }
  }
  return webviewPath
}
